"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function MenuButtons(_a) {
    var id = _a.id;
    return react_1.default.createElement(storybook_1.Menus.Dashboard.Buttons, null,
        react_1.default.createElement(storybook_1.Buttons.Link, { type: 'secondary', to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/videos/" + id + "/edit", className: 'mr-2' },
            react_1.default.createElement("small", null, "Terug"),
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'movie' })),
        react_1.default.createElement(storybook_1.Buttons.Link, { type: 'secondary', target: '_blank', to: process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/videos/" + id + "/preview" },
            react_1.default.createElement("small", null, "Preview"),
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'play' })));
}
exports.default = MenuButtons;
MenuButtons.propTypes = {
    id: prop_types_1.default.number.isRequired,
};
